(function () {
  "use strict";

  if (window.n9MimaPackageInitialized) {
    return;
  }
  window.n9MimaPackageInitialized = true;

  var CAR_SEAT_HANDLES = {
    "mima-go-beyond-car-seat": true
  };
  var CARRYCOT_HANDLES = {
    "creo-bassinet": true,
    "xari-max-bassinet": true
  };
  var ADAPTER_HANDLES = {
    "mima-miro-car-seat-adapter-set": true
  };

  function selectedPackage() {
    var input = document.querySelector('.n9-package-picker input[type="radio"]:checked');
    if (input && input.value) {
      return input.value;
    }
    var select = document.querySelector('select[data-n9-option="package"]');
    if (select) {
      return select.value || "";
    }
    return "";
  }

  function shouldHide(pkg, handle) {
    if (!handle) {
      return false;
    }
    var hasCarSeat = /travel system/i.test(pkg) || /car seat/i.test(pkg) || /babyschale/i.test(pkg) || /3 in 1/i.test(pkg);
    var hasCarrycot = /2 in 1/i.test(pkg) || /3 in 1/i.test(pkg) || /carrycot/i.test(pkg) || /babywanne/i.test(pkg);
    var hasAdapters = /travel system/i.test(pkg) || /adapter/i.test(pkg) || /adaptern/i.test(pkg);
    if (CAR_SEAT_HANDLES[handle] && hasCarSeat) {
      return true;
    }
    if (CARRYCOT_HANDLES[handle] && hasCarrycot) {
      return true;
    }
    if (ADAPTER_HANDLES[handle] && hasAdapters) {
      return true;
    }
    return false;
  }

  function syncUpsells() {
    var pkg = selectedPackage();
    var cards = Array.from(document.querySelectorAll(".f8pr-upsell [data-n9-upsell-handle]"));
    if (!cards.length) {
      return;
    }

    cards.forEach(function (card) {
      var hide = shouldHide(pkg, card.getAttribute("data-n9-upsell-handle"));
      card.classList.toggle("n9-package-included", hide);
      if (hide) {
        var checkbox = card.querySelector('input[type="checkbox"][data-id]');
        if (checkbox && checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });

    var visibleLimit = 2;
    var shown = 0;
    cards.forEach(function (card) {
      if (card.classList.contains("n9-package-included")) {
        return;
      }
      shown += 1;
      if (shown <= visibleLimit) {
        card.classList.remove("hidden");
        card.removeAttribute("data-element");
      } else {
        card.classList.add("hidden");
        card.setAttribute("data-element", "unique-more-products-class");
      }
    });

    var moreWrap = document.querySelector('.f8pr-upsell [data-toggle="unique-more-products-class"]');
    if (moreWrap) {
      var row = moreWrap.closest("p") || moreWrap;
      row.classList.toggle("hidden", shown <= visibleLimit);
    }
  }

  document.addEventListener("change", function (event) {
    var target = event.target;
    if (!target) {
      return;
    }
    if (target.closest && target.closest(".n9-package-picker")) {
      syncUpsells();
    }
  });

  window.addEventListener("themeVariantUpdated", syncUpsells);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncUpsells);
  } else {
    syncUpsells();
  }
})();
